import flagSvg from './de-flag.svg';

export default function DeFlag() {
  return <img src={flagSvg} alt="English " />;
}
